<template>
    <div class="case-studies-details-area ptb-100" id="clientii-nostri">
        <div class="container">
            <div class="section-title">
                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Clienți</span>
                <h2>Parteneriate de succes</h2>
            </div>

            <div class="why-choose-us-wrapper">
                <div class="why-choose-us-area bg-color">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8 col-md-12">
                                <div class="why-choose-us-content">
                                    <h2>De ce noi?</h2>
                                    <p>Alegeți Atelierul de Software pentru a lucra direct cu o echipă de experți, fără intermediari sau birocrație. Comunicarea este directă cu "meșterii" care construiesc soluția, ceea ce garantează o înțelegere profundă a nevoilor dumneavoastră, viteză și eficiență.</p>
                                    <p>Parteneriatul cu noi este o investiție pe termen lung. Vă optimizăm prezentul cu soluții personalizate care rezolvă problemele curente și, simultan, vă integrăm viitorul prin platforme scalabile, gata de creștere. Nu livrăm doar cod, ci fundația succesului de mâine.</p>
                                    <!-- <router-link to="#about-us" class="default-btn"><i class="flaticon-right"></i>Despre noi<span></span></router-link> -->
                                    <!-- <div class="map-shape2"><img src="../assets/images/shape/map-shape2.png" alt="image"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="our-brand-partners-list pt-100">
                <div class="container">
                    <div class="our-brand-partners-list">
                        <h2>Partenerii noștri</h2>
                        <div class="row align-items-center">
                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://influent.ro/" target="_blank">
                                    <img src="../assets/images/partner/influent.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://expressdst.ro/" target="_blank">
                                    <img src="../assets/images/partner/eid.png" alt="image">
                                </a>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.naturalness.ro/" target="_blank">
                                    <img src="../assets/images/partner/naturalness.png" alt="image">
                                </a>
                            </div>
                            
                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://titanzalau.ro/" target="_blank">
                                    <img src="../assets/images/partner/titan.png" alt="image">
                                </a>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://softmagazin.ro/" target="_blank">
                                    <img src="../assets/images/partner/softmagazin.png" alt="image">
                                </a>
                            </div>
                            
                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.adinabuzatu.ro/" target="_blank">
                                    <img src="../assets/images/partner/trends.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.dpparfum.ro/" target="_blank">
                                    <img src="../assets/images/partner/dp.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.uttis.com/ro/" target="_blank">
                                    <img src="../assets/images/partner/uttis.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://philinea.ro/" target="_blank">
                                    <img src="../assets/images/partner/philinea.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.dablerom.com/" target="_blank">
                                    <img src="../assets/images/partner/dablerom.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://dadacomapel.ro/" target="_blank">
                                    <img src="../assets/images/partner/dada.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://hvac-solutions.ro/" target="_blank">
                                    <img src="../assets/images/partner/torn.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://free-star.ro/" target="_blank">
                                    <img src="../assets/images/partner/freestar.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://alke.ro/" target="_blank">
                                    <img src="../assets/images/partner/alke.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.axmgroup.ro/" target="_blank">
                                    <img src="../assets/images/partner/axm.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.flexographic.ro/" target="_blank">
                                    <img src="../assets/images/partner/flexographic.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://cardiff.ro/" target="_blank">
                                    <img src="../assets/images/partner/cardiff.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://ai-heatingsolutions.ro/" target="_blank">
                                    <img src="../assets/images/partner/aiheating.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.tinar.ro/" target="_blank">
                                    <img src="../assets/images/partner/tinar.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://akproduction.ro/" target="_blank">
                                    <img src="../assets/images/partner/akproduction.png" alt="image">
                                </a>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 partner-logo">
                                <a href="https://www.emdep.com/offices/ebro/" target="_blank">
                                    <img src="../assets/images/partner/etestboards.png" alt="image">
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
    </div>

        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent ({
    name: 'ASClientiiNostri',
    components: {
    },
    data: () => ({
    }),
})
</script>

<style scoped>
.why-choose-us-wrapper {
    position: relative;
    z-index: 1;
}

@media (min-width: 992px) {
    .why-choose-us-wrapper {
        margin-bottom: -250px;
    }
}

@media (max-width: 991px) {
    .why-choose-us-wrapper {
        margin-bottom: -75px;
    }
}

/* @media (max-width: 767px) {
    .why-choose-us-wrapper {
        margin-bottom: -75px;
    }
}

@media (max-width: 576px) {
    .why-choose-us-wrapper {
        margin-bottom: -75px;
    }
} */


@media (max-width: 767px) {
    .partner-logo {
        padding: 15px;
    }
}
</style>